// Avatar utilisateur : photo ou initiales sur fond chaleureux
export const UserAvatar = ({ user, size = "md", className = "" }) => {
  const tailles = { sm: "h-6 w-6 text-[10px]", md: "h-8 w-8 text-xs", lg: "h-10 w-10 text-sm" };
  const initiales = (user?.name || "?")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  if (user?.photo_url) {
    return (
      <img
        src={user.photo_url}
        alt={user.name}
        title={user.name}
        className={`${tailles[size]} rounded-full object-cover ring-2 ring-background ${className}`}
      />
    );
  }
  return (
    <div
      title={user?.name}
      className={`${tailles[size]} rounded-full bg-primary/90 text-primary-foreground flex items-center justify-center font-medium ring-2 ring-background ${className}`}
    >
      {initiales}
    </div>
  );
};
